import { Breadcrumb, Col, Form, Input, Layout, notification, Radio, Row, Space } from 'antd';
import classNames from 'classnames/bind';
import 'moment/locale/vi';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import orderAPI from '~/api/OrderAPI';
import config from '~/config';
import { payments } from '~/constants/payments';
import PageNotFound from '~/pages/PageNotFound';
import { updateComboServiceCartStore } from '~/store/actions/CartComboServiceAction';
import { getNumberWithCommas } from '~/utils';
import styles from './CheckOutComboService.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const { Content } = Layout;
const { TextArea } = Input;

const cx = classNames.bind(styles);

export default function CheckOutComboService() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userInfo = useSelector((state) => state.user.userInfo);
    const cartComboServiceInfo = useSelector((state) => state.cartComboService.cartComboServiceInfo);

    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');
    const totalPriceComboServiceOrder = localStorage.getItem('totalPriceComboServiceOrder');
    const comboServiceOrder = JSON.parse(localStorage.getItem('comboServiceOrder'));

    const [payment, setPayment] = useState('CASH');

    const [idComboService, setIdComboService] = useState([]);

    const [form] = Form.useForm();
    const initialValues = {
        name: userInfo?.fullname || '',
        phone: userInfo?.phone || '',
        note: '',
    };

    const onFinish = (values) => {
        if (comboServiceOrder?.length) {
            const data = {
                fullname: values.name,
                phone: values.phone,
                payment_type: payment,
                note: values.note || '',
                order_item: idComboService,
                order_type: 'COMBO',
            };

            createOrder(data);
        } else {
            notification.open({
                message: 'Please select a product to order',
                duration: 2,
                placement: 'top',
            });
        }
    };

    const createOrder = async (data) => {
        try {
            const res = await orderAPI.orderProductAPI(data);

            if (res.code === 200) {
                notification.open({
                    message: 'Order successful',
                    duration: 2,
                    placement: 'top',
                });
                const new_cart = cartComboServiceInfo.filter(
                    (elem) => !comboServiceOrder.find(({ id }) => elem.id === id),
                );
                dispatch(updateComboServiceCartStore(new_cart));
                navigate(config.routes.home);
            }
        } catch (err) {
            console.log(err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };

    const onChangePayment = (e) => {
        setPayment(e.target.value);
    };

    const handleSetIdComboService = () => {
        let id_comboService = [];
        for (const item of comboServiceOrder) {
            let combo_service = {
                item_id: item.id,
                quantity: item.amount_order,
            };
            id_comboService.push(combo_service);
        }
        setIdComboService(id_comboService);
    };

    useEffect(() => {
        handleSetIdComboService();
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangMuaComboDichVu');
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {isLogin ? (
                <Layout className={cx('wrapper')} style={{ backgroundColor: '#fff' }}>
                    <Content>
                        <Breadcrumb className={cx('breadcrumb')}>
                            <Breadcrumb.Item>Service package information</Breadcrumb.Item>
                            <Breadcrumb.Item className={cx('breadcrumbItemActive')}>Place order</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className={cx('headingBlock')}>
                            <h3>Order</h3>
                        </div>
                        <div className={cx('contentBlock')}>
                            <Form onFinish={onFinish} form={form} initialValues={initialValues}>
                                <Row gutter={16}>
                                    {/* Left */}
                                    <Col lg={12} md={24} xs={24}>
                                        <div className={cx('infoBlock')}>
                                            <div className={cx('heading')}>Customer information</div>
                                            <Row gutter={[20, 16]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name="name"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter a name',
                                                            },
                                                        ]}
                                                    >
                                                        <Input placeholder="Name *" className={cx('item_input')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name="phone"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter phone number',
                                                            },
                                                            {
                                                                pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                                                                message: 'Wrong phone number format',
                                                            },
                                                            { min: 10, message: 'Phone number must have 10 digits' },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Phone number *"
                                                            className={cx('item_input')}
                                                            maxLength={10}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <div className={cx('heading')}>Payment method</div>
                                            <Row>
                                                <Radio.Group onChange={onChangePayment} value={payment}>
                                                    <Space direction="vertical">
                                                        {payments?.map((item) => {
                                                            return <Radio value={item.value}>{item.title}</Radio>;
                                                        })}
                                                    </Space>
                                                </Radio.Group>
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <div className={cx('heading')}>Notes</div>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <Form.Item name="note">
                                                        <TextArea placeholder="Notes" rows={3} maxLength={255} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    {/* Right */}
                                    <Col lg={12} md={24} xs={24}>
                                        <div className={cx('infoBlock')}>
                                            <div className={cx('heading')}>Order information</div>
                                            <div className={cx('infoBooking')}>
                                                <div className={cx('headingInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col xs={12} md={15}>
                                                                        <span className={cx('nameService')}>
                                                                            Product
                                                                        </span>
                                                                    </Col>

                                                                    <Col xs={12} md={9} style={{ textAlign: 'right' }}>
                                                                        <span>Cost</span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className={cx('contentInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={[16, 10]}>
                                                                    {comboServiceOrder?.length &&
                                                                        comboServiceOrder?.map((item) => (
                                                                            <Fragment key={item?.key}>
                                                                                <Col xs={12} md={15}>
                                                                                    <span>
                                                                                        {item?.amount_order}
                                                                                        x&nbsp;&nbsp;
                                                                                        {item?.title}
                                                                                    </span>
                                                                                </Col>

                                                                                <Col
                                                                                    xs={12}
                                                                                    md={9}
                                                                                    style={{ textAlign: 'right' }}
                                                                                >
                                                                                    <span>
                                                                                        {getNumberWithCommas(
                                                                                            item?.total_price,
                                                                                        )}
                                                                                        d
                                                                                    </span>
                                                                                </Col>
                                                                            </Fragment>
                                                                        ))}
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className={cx('contentInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <span className={cx('total-title')}>
                                                                            Total order
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                                        <span className={cx('total-price')}>
                                                                            {getNumberWithCommas(
                                                                                totalPriceComboServiceOrder || 0,
                                                                            )}
                                                                            d
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <button className={cx('btnBooking')}>Book now</button>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Content>
                </Layout>
            ) : (
                <PageNotFound />
            )}
        </>
    );
}
